import { Component, ContentChildren, forwardRef, Input, QueryList } from "@angular/core";
import { COMPONENT_DEFINITION_REF } from "../../utility/component-definition-token";
import { MetricDetailComponent } from "../metric/metric-detail.component";
import { PropertyComponent } from "../property/property.component";

@Component({
    selector: 'thing-group',
    template: '',
    providers: [{ provide: COMPONENT_DEFINITION_REF, useExisting: forwardRef(() => LocationSchemaThingGroupComponent) }]
})
export class LocationSchemaThingGroupComponent {

    @Input() name: string;

    @Input() query: { property: string, predicate: string, value: any }[];

    @ContentChildren(COMPONENT_DEFINITION_REF) columnComponents: QueryList<PropertyComponent | MetricDetailComponent>;

}